import React, { useState, useEffect, useContext, createContext, useMemo, } from 'react';
const ContentContext = createContext({
    content: undefined,
    isInInitialViewport: false,
});
export function ContentContextProvider({ children, contentService, }) {
    const [content, setContent] = useState(contentService.getContent());
    const isInInitialViewport = contentService.isInInitialViewport();
    useEffect(() => {
        const listener = () => {
            setContent(contentService.getContent());
        };
        contentService.onContentChange(listener);
        return () => {
            contentService.removeOnContentChange(listener);
        };
    }, [contentService]);
    const value = useMemo(() => ({ content, isInInitialViewport }), [content]);
    return React.createElement(ContentContext.Provider, { value: value }, children);
}
export function useContent() {
    const { content } = useContext(ContentContext);
    return content !== undefined ? content : undefined;
}
export function useInitialViewport() {
    const { isInInitialViewport } = useContext(ContentContext);
    return isInInitialViewport;
}
//# sourceMappingURL=index.js.map